<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
	<div class="flex flex-column align-items-center justify-content-center">
		<img [src]="getMenuTheme() === 'dim' ? './assets/images/logos/CAME-A_alpha_white_blue.png' : './assets/images/logos/CAME-A_alpha_white.png'" alt="CAME Logo" class="mb-6 w-16rem flex-shrink-0">
		<div class="card surface-800 border-round flex align-items-center justify-content-center p-0">
			<div class="w-full p-8 flex flex-column align-items-center">
				<div class="font-bold text-5xl lg:text-7xl mb-2 text-center">Work in progress</div>
				<div class="font-bold text-5xl lg:text-6xl mb-2 text-center">Coming soon</div>
				<i class="mt-5 pi pi-hourglass" style="font-size: 14rem"></i>
			</div>
		</div>
	</div>
</div>